import styled from "../styles/styled"

const BarColumn = styled("div")(({ theme }) => ({
  minWidth: theme.barWidth,
  width: theme.barWidth
}))

export default BarColumn
